import React, { memo } from 'react';
import { ColorTokens, StackType, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, DividerSizeTokens, } from '@voltmoney/schema';
import { Dimensions, FlatList, Image, View, } from 'react-native';
import Stack from '../stack/Stack';
import Typography from '../typography/Typography';
import Space from '../space/Space';
import ThemeProvider from '@voltmoney/theme';
import { getScreenType, isMobile } from '../stack/utils';
import Divider from '../divider/Divider';
import { isFromTDLPlatform } from '../pages/utils';
/**
 * Primary UI component for user interaction
 */
const PromoCard = ({ heading, data }) => {
    const theme = ThemeProvider.getTheme();
    const colorMap = theme.colors;
    const isfromTDL = isFromTDLPlatform();
    const separator = () => {
        return (React.createElement(Divider, { size: DividerSizeTokens.SM, margin: { vertical: SizeTypeTokens.LG }, color: ColorTokens.Grey_Chalk }));
    };
    return (React.createElement(View, { style: {
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: colorMap[ColorTokens.Primary_10],
            backgroundColor: colorMap[ColorTokens.White],
            padding: 16,
        } },
        React.createElement(Stack, null,
            React.createElement(Typography, { label: heading, fontFamily: FontFamilyTokens.Poppins, fontWeight: '700', fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night }),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(FlatList, { data: data, style: isfromTDL ? { borderWidth: 1, borderRadius: 12, borderColor: '#78787D3D', paddingHorizontal: 16, paddingVertical: 12, width: '100%' } : {}, ItemSeparatorComponent: isfromTDL ? separator : null, renderItem: ({ item, index }) => (React.createElement(View, { style: { flexDirection: 'row', ...isfromTDL && { width: '100%' } } },
                    React.createElement(Image, { source: { uri: item['image'] }, style: {
                            height: 24,
                            width: 24,
                            borderRadius: 30,
                        } }),
                    React.createElement(Space, { size: SizeTypeTokens.XXL }),
                    React.createElement(Stack, { type: StackType.column },
                        React.createElement(Typography, { label: item['title'], fontFamily: FontFamilyTokens.Inter, fontWeight: '600', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night }),
                        React.createElement(Space, { size: SizeTypeTokens.SM }),
                        React.createElement(View, { style: { width: (isMobile(getScreenType(Dimensions.get('window').width)) && index >= data.length - 1) ? '90%' : "100%" } },
                            React.createElement(Typography, { label: item['subTitle'], fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Night })),
                        index < data.length - 1 && !isfromTDL && (React.createElement(Space, { size: SizeTypeTokens.XXL }))))), keyExtractor: (item) => item['id'] }))));
};
export default memo(PromoCard);
export { PromoCard };
